module.exports = function getFunctionName(f) {
  return f.displayName || f.name || '<function' + f.length + '>';
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/tcomb/lib/getFunctionName.js
// module id = 67
// module chunks = 0